import { getSwiperInterior, openPopupInterior } from "./popup";
import { baseUrl, getData, showInterior } from "./utils";

const data = getData();
const points = [];

let panorama, viewer;

function initInterior() {
  // showInterior();
  const imgExt = data.interior.imgExt ?? "webp";
  const imgUrl = `${baseUrl}/${data.folder}/interior/1.${imgExt}`;

  panorama = new PANOLENS.ImagePanorama(imgUrl);

  viewer = new PANOLENS.Viewer({
    container: document.getElementById("j360_interior"),
    controlButtons: ["fullscreen"],
    initialLookAt: new THREE.Vector3(80000, 0, 0),
    rotateSpeed: -0.25,
  });

  if (data && data.interior && data.interior.points) {
    data.interior.points.forEach((point, i) => {
      points.push(renderPoint(point, i));
    });
  }

  // -- handle swiper events
  handleSlide();

  viewer.add(panorama);
}

function renderPoint(pos, i) {
  const circleSize = 120;

  const texture = new THREE.CanvasTexture(
    createCircleTexture(100, "#FFB74B", true)
  );

  texture.minFilter = THREE.NearestFilter;

  const circleMaterial = new THREE.SpriteMaterial({
    map: texture,
    transparent: true,
    opacity: 0.9,
  });

  const circle2Material = new THREE.SpriteMaterial({
    map: new THREE.CanvasTexture(createCircleTexture(100, "#FFB74B")),
    transparent: true,
    opacity: 0.2,
  });

  const circle = new THREE.Sprite(circleMaterial);
  const circle2 = new THREE.Sprite(circle2Material);

  // Set the scale of the circle (adjust the size as needed)
  circle.scale.set(circleSize, circleSize, 1); // Customize the size
  circle2.scale.set(circleSize, circleSize, 1); // Customize the size

  // Position the circle in 3D space
  circle.position.set(pos[0], pos[1], pos[2]);
  circle2.position.set(pos[0], pos[1], pos[2]);

  // click listener
  circle.addEventListener("click", function () {
    openPopupInterior(i);
    viewer.tweenControlCenterByObject(circle);
  });

  circle2.addEventListener("click", () => {
    openPopupInterior(i);
    viewer.tweenControlCenterByObject(circle);
  });

  circle.addEventListener("hoverenter", function () {
    panorama.container.style.cursor = "pointer";
  });

  circle2.addEventListener("hoverenter", function () {
    panorama.container.style.cursor = "pointer";
  });

  circle.addEventListener("hoverleave", function () {
    panorama.container.style.cursor = "default";
  });

  circle2.addEventListener("hoverleave", function () {
    panorama.container.style.cursor = "default";
  });

  // Add the circle to the panorama
  panorama.add(circle2);
  panorama.add(circle);

  let animateUp = true;

  function animate() {
    requestAnimationFrame(animate);

    // circle2.scale.set(circleSize, circleSize, 1); // Customize the size
    if (animateUp) {
      circle2.scale.x += 4;
      circle2.scale.y += 4;
      animateUp = circle2.scale.x < circleSize * 3;
    } else {
      circle2.scale.x -= 4;
      circle2.scale.y -= 4;
      animateUp = circle2.scale.x <= circleSize;
    }
  }

  animate();

  return circle;
}

// Function to create a circular texture
function createCircleTexture(radius, color, outer = false) {
  var canvas = document.createElement("canvas");
  var context = canvas.getContext("2d");
  var borderWidth = 10;
  var borderOffset = 32;
  var size = (radius + borderWidth + borderOffset) * 2; // Adjust the size to accommodate the border
  canvas.width = size;
  canvas.height = size;

  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = "high";

  context.beginPath();
  context.arc(size / 2, size / 2, radius, 0, Math.PI * 2, false);
  context.fillStyle = color;
  context.fill();
  context.lineWidth = 1;
  context.strokeStyle = color;
  context.stroke();

  if (outer) {
    // Draw the outer border circle
    context.arc(
      size / 2,
      size / 2,
      radius + borderWidth / 2 + borderOffset,
      0,
      Math.PI * 2,
      false
    );
    context.strokeStyle = color;
    context.lineWidth = borderWidth;
    context.stroke();
  }

  return canvas;
}

function handleSlide() {
  const swiper = getSwiperInterior();
  if (swiper) {
    swiper.on("slideChange", function (ev) {
      const ind = ev.realIndex;
      viewer.tweenControlCenterByObject(points[ind]);
    });
  }
}

// camera events.

export default initInterior;
